import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'
import React from 'react'
import { DialogContent, SvgIcon } from '@mui/material'

export const SidebarItemText = styled.span`
  color: ${({ disabled }) => (disabled ? '#8b8b8b' : '#fff')};
  font-family: Outfit;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-left: 15px;
  min-width: 130px;
  @media (min-width: 768px) {
    min-width: 170px;
    font-size: 20px;
  }
`
export const SidebarItemContainer = styled.div`
  display: none;
  justify-content: flex-start;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: calc(100% - 30px);
  @media (min-width: 768px) {
    width: calc(100% - 40px);
  }
`

export const SidebarItemIcon = muiStyled('img')`
  width: 25px;
  height: 25px;
  color: ${({ disabled }) => (disabled ? '#8b8b8b' : '#fff')};
  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`

export const SidebarContainer = styled.div`
  width: 70px;
  min-height: 100vh;
  overflow: hidden;
  background: #434343;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  color: #fff;
  font-family: Outfit;
  padding: 25px 18px;
  &:hover {
    width: 230px;
    align-items: flex-start;
    ${SidebarItemContainer} {
      display: flex;
    }
    ${SidebarItemIcon} {
      margin-left: 17px;
    }
  }
  @media (min-width: 768px) {
    width: 100px;
    padding: 25px 25px;
    &:hover {
      width: 340px;
      align-items: flex-start;
      ${SidebarItemContainer} {
        display: flex;
      }
      ${SidebarItemIcon} {
        margin-left: 17px;
      }
    }
  }
  @media print {
    display: none;
  }
`

export const StyledLogo = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 3px;
  margin: 0 auto 100px auto;
  @media (min-width: 768px) {
    width: 55px;
    height: 55px;
    border-radius: 6px;
  }
`

export const SidebarKycIcon = muiStyled('img')`
    height: 40px;
    width: 40px;
`
export const KycSidebarPendingContent = muiStyled(DialogContent)`
display: flex;
justify-content: center;
gap: 20px;
align-items: center;
`
export const KycApprovalHeading = muiStyled('div')`
font-size: 16px;
    font-weight: 600;
`
